/**
 * /superadmin — redirect to the Tenants directory (the console's
 * landing surface). The Platform sidebar entry in lib/nav.ts points at
 * /superadmin; this keeps that link from landing on an empty shell.
 */

import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authgated/superadmin/")({
  component: () => <Navigate to="/superadmin/tenants" replace />,
});
